export default __webpack_public_path__ + "static/media/add_manual_journey.e7f1b7bc.png";